/* eslint-disable no-use-before-define,no-restricted-globals */
export const safeURL = (url, defVal) => {
    try { return new URL(url) } catch(x) { return defVal }
}

export const fixURL = (url) => {
    let u = typeof(url)==='string' ? safeURL(url) : url
    let isEtrade = u.host.indexOf('etrade.com')>=0
    let isBonddesk = u.host.indexOf('bonddesk.com')>=0

    let isQa = location.host.indexOf('qa')>=0
    let isTst1 = location.host.indexOf('tst1')>=0
    if ((isQa || isTst1) && (isEtrade || isBonddesk)) {
        let dom = isEtrade ? 'uat' :
            isBonddesk && isQa ? 'qa' :
            isBonddesk && isTst1 ? 'tst1' :
            ''
        let arr = u.host.split('.')
        if (arr.length===3) {
            arr.splice(1,0,dom)
            u.host = arr.join('.')
        }
    }
    return u
}



export const openWindow = (url, name, option) => {
    let u = safeURL(url)
    if (!u) {
        return window.open(url, name, option)
    }

    fixURL(u)

    if (name) {
        return window.open(u.toString(), name, option)
    } else {
        location.href = u.toString()
        return this
    }
}

